import { Table } from "antd";
import KoboConverter from "Components/KoboConverter";
import { useGetCustomerWalletActivitiesQuery } from "hooks/CustomerManagement/useGetCustomerWalletActivitiesQuery";
import React from "react";
import Moment from "react-moment";
import { useParams } from "react-router-dom";

const WalletTransactions = () => {
  const { id } = useParams();
  const { data } = useGetCustomerWalletActivitiesQuery({ id });

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <span
          className={`p-2 rounded-md text-white ${
            status === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {status ? status : "n/a"}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type: string | null) => (
        <span
          className={`capitalize ${
            type === "credit" ? "text-red-500" : "text-green-500"
          }`}
        >
          {type ? type : "N/A"}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount: any) => <KoboConverter amount={amount} />,
    },
    {
      title: "Wallet",
      dataIndex: "wallet",
      key: "wallet",
      // render: (amount: any) => <KoboConverter amount={amount} />,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string | null) => (
        <span className="">
          {createdAt ? (
            <Moment
              interval={0}
              format="DD-MM-YYYY hh:mm a"
              className="text-[#939393] italic"
            >
              {createdAt}
            </Moment>
          ) : (
            "N/A"
          )}
        </span>
      ),
    },
    {
      title: "Purpose",
      dataIndex: "purpose",
      key: "purpose",
      render: (purpose: string | null) => (
        <span className="">{purpose ? purpose : "N/A"}</span>
      ),
    },
  ];
  return (
    <div className="mt-[20px] px-[40px]">
      <h2 className="text-[#562B00] text-[20px] font-semibold">
        Wallet Transactions
      </h2>
      <Table
        // rowKey="id"
        columns={columns}
        // pagination={pagination}
        // rowSelection={rowSelection}
        // onChange={handleTableChange}
        scroll={{ y: "70vh" }}
        dataSource={data?.data?.docs}
        className="manrope mt-[20px]"
      />
    </div>
  );
};

export default WalletTransactions;
